export default __webpack_public_path__ + "img/Image-500@1x.5f8285557b254eddc39ed107536b397d.png";